import { AppContext } from '@edx/frontend-platform/react';
import { useContext, useEffect, useState } from "react";
import useAddToCart from "../hooks/useAddToCart";
import useDeleteCartItem from "../hooks/useDeleteCartItem";
import { useCart } from '@blend-ed/blendx-platform/hooks';
import useUpdateCart from "../hooks/useUpdateCart";
import { useOrgId } from '@blend-ed/blendx-platform/hooks';

const useHandleCart = () => {
    const { authenticatedUser } = useContext(AppContext);

    const { data: cartData, loading: cartLoading, error: cartError, refetch: refetchCart } = useCart();
    const { insertProgramToCart, insertCourseToCart } = useAddToCart();
    const { updateCart, data: updateCartData, loading: updateCartLoading, error: updateCartError } = useUpdateCart();
    const { deleteCartItem, data: deleteCartData, loading: deleteCartLoading, error: deleteCartError } = useDeleteCartItem();
    const orgId = useOrgId()

    const [programsInCart, setProgramsInCart] = useState([])
    const [programsInWishlist, setProgramsInWishlist] = useState([])
    const [coursesInCart, setCoursesInCart] = useState([])
    const [coursesInWishlist, setCoursesInWishlist] = useState([])

    useEffect(() => {
        if (cartData) {
            setProgramsInCart(cartData.cart.filter(item => item.status === 'draft' || item.status === 'pending').map(item => item.programId).filter(item => item !== null))
            setProgramsInWishlist(cartData.cart.filter(item => item.status === 'wishlist').map(item => item.programId).filter(item => item !== null))
            setCoursesInCart(cartData.cart.filter(item => item.status === 'draft' || item.status === 'pending').map(item => item.courseId).filter(item => item !== null))
            setCoursesInWishlist(cartData.cart.filter(item => item.status === 'wishlist').map(item => item.courseId).filter(item => item !== null))
        }
    }, [cartData])

    // handle programs cart
    const handleProgramsCart = (programId, type, status,) => {
        if (type == "delete") {
            // delete entry from table
            const keyId = cartData.cart.map(item => {
                if (item.programId === programId) {
                    return item.id
                }
            }).filter(item => item !== undefined)
            deleteCartItem({
                variables: {
                    keyId: keyId[0]
                },
                onCompleted: () => {
                    refetchCart()
                }
            })
        }

        if (type == 'insert' && status == 'draft') {
            if (programsInWishlist.includes(programId)) {
                // change the status to draft
                const keyId = cartData.cart.map(item => {
                    if (item.programId === programId) {
                        return item.id
                    }
                }).filter(item => item !== undefined)
                updateCart({
                    variables: {
                        keyId: keyId[0],
                        status: status
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            } else {
                // add new entry as draft
                insertProgramToCart({
                    variables: {
                        organisationId: orgId,
                        programId: programId,
                        status: status,
                        userId: authenticatedUser.id
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            }
        }

        if (type == "insert" && status == 'wishlist') {
            if (programsInCart.includes(programId)) {
                // change the status to wishlist
                const keyId = cartData.cart.map(item => {
                    if (item.programId === programId) {
                        return item.id
                    }
                }).filter(item => item !== undefined)
                updateCart({
                    variables: {
                        keyId: keyId[0],
                        status: status
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            } else {
                // add new entry as wishlist
                insertProgramToCart({
                    variables: {
                        organisationId: orgId,
                        programId: programId,
                        status: status,
                        userId: authenticatedUser.id
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            }
        }
    }

    // handle courses cart
    const handleCoursesCart = (courseId, type, status) => {
        if (type == "delete") {
            // delete entry from table
            const keyId = cartData.cart.map(item => {
                if (item.courseId === courseId) {
                    return item.id
                }
            }).filter(item => item !== undefined)
            deleteCartItem({
                variables: {
                    keyId: keyId[0]
                },
                onCompleted: () => {
                    refetchCart()
                }
            })
        }

        if (type == 'insert' && status == 'draft') {
            if (coursesInWishlist.includes(courseId)) {
                // change the status to draft
                const keyId = cartData.cart.map(item => {
                    if (item.courseId === courseId) {
                        return item.id
                    }
                }).filter(item => item !== undefined)
                updateCart({
                    variables: {
                        keyId: keyId[0],
                        status: status
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            } else {
                // add new entry as draft
                insertCourseToCart({
                    variables: {
                        organisationId: orgId,
                        courseId: courseId,
                        status: status,
                        userId: authenticatedUser.id
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            }
        }

        if (type == "insert" && status == 'wishlist') {
            if (coursesInCart.includes(courseId)) {
                // change the status to wishlist
                const keyId = cartData.cart.map(item => {
                    if (item.courseId === courseId) {
                        return item.id
                    }
                }).filter(item => item !== undefined)
                updateCart({
                    variables: {
                        keyId: keyId[0],
                        status: status
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            } else {
                // add new entry as wishlist
                insertCourseToCart({
                    variables: {
                        organisationId: orgId,
                        courseId: courseId,
                        status: status,
                        userId: authenticatedUser.id
                    },
                    onCompleted: () => {
                        refetchCart()
                    }
                })
            }
        }
    }

    return { handleProgramsCart, handleCoursesCart, programsInCart, programsInWishlist, coursesInCart, coursesInWishlist }
}

export default useHandleCart
